<template>
  <div class="v-view table-view a-fadeIn" :style="{ height: span * 33.33 + '%' }">
    <div class="v-title">{{ title }}</div>

    <table class="tv-table">
      <thead class="tv-table-head" align="center">
        <tr>
          <th v-for="(item, index) in tableHead" :key="index">
            {{ item }}
          </th>
        </tr>
      </thead>

      <tbody v-if="tableList.length > 0" ref="table" class="tv-table-body" align="center">
        <tr v-for="item in tableList" :key="item.id">
          <td class="td-empha">{{ item.id }}</td>
          <td>{{ item.organ }}</td>
          <td>{{ item.time }}</td>
        </tr>
      </tbody>
      <tbody v-else class="tv-table-nodata">
        <tr>
          <td colspan="5">暂无数据!</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'ServiceRecord',
  computed: {
    ...mapGetters(['cid']),
  },
  props: {
    span: {
      type: Number,
      default: 1,
    },
    title: {
      type: String,
      default: '可疑服务记录',
    },
  },
  watch: {
    tableData(newData, oldData) {
      const newItem = newData.length && newData[0]
      const oldItem = oldData.length && oldData[0]
      if (!oldItem || newItem.Name !== oldItem.Name) {
        this.tableList = newData.map((item) => ({
          id: item.Name,
          organ: item.Value,
          time: item.Data,
        }))
        this.$nextTick(() => {
          !this.animInterval && this.startAnimation()
        })
      }
    },
  },
  data() {
    return {
      animInterval: null,
      dataInterval: null,
      tableHead: ['工单编号', '居家服务组织', '时间'],
      tableData: [],
      tableList: [],
    }
  },
  created() {
    this.getServiceRecordData(this.cid)
  },
  mounted() {
    this.dataInterval = setInterval(() => {
      this.getServiceRecordData(this.cid)
    }, this.$interval)
  },
  beforeDestroy() {
    if (this.animInterval) {
      clearInterval(this.animInterval)
      this.animInterval = null
    }
    if (this.dataInterval) {
      clearInterval(this.dataInterval)
      this.dataInterval = null
    }
  },
  methods: {
    startAnimation() {
      const node = this.$refs.table
      if (node && node.childNodes.length > 1) {
        this.animInterval = setInterval(() => {
          const newChild = node.firstChild.cloneNode(true)
          newChild.classList.add('animated', 'fadeInUp')
          node.appendChild(newChild)
          node.removeChild(node.firstChild)
        }, 3000)
      }
    },
    getServiceRecordData(cid) {
      this.$api
        .getServiceRecord(cid)
        .then((data) => {
          // console.log(data)
          if (!data || !data.length) return
          this.tableData = data
        })
        .catch((error) => {
          console.error(error)
        })
    },
  },
}
</script>
